import React, { useEffect } from "react";
import "./Projects.css";
import Aos from "aos";
import "aos/dist/aos.css";
import { Link } from "react-router-dom";
import projectList from "./Projectlist";
const Projects = () => {
	useEffect(() => {
		Aos.init();
	}, []);
	return (
		<>
			<div className="Project">
				<header className="heading">
					<h1>Projects</h1>
				</header>
				<div className="gridDad">
					<div className="allprpjects">
						{projectList.map((items) => {
							return (
								<div className="controllSards" key={items.id}>
									<div
										className="BoxCards"
										data-aos="fade"
										data-aos-duration="2000"
									>
										<div id="cards_landscape_wrap-2">
											<div class="row">
												<div class="col-xs-12 col-sm-6 col-md-3 col-lg-3">
													<Link to={items.projectUrl}>
														<div class="card-flyer">
															<div class="text-box">
																<div class="image-box">
																	<img src={items.imageUrlL} alt="img" />
																</div>
																<div class="text-container">
																	<h6>{items.name}</h6>
																	<p>{items.description}</p>
																</div>
															</div>
														</div>
													</Link>
												</div>
											</div>
										</div>
									</div>
								</div>
							);
						})}
					</div>
				</div>
			</div>
		</>
	);
};

export default Projects;
